//to create a Product object as per database data
export default class FreightCompany{

    constructor(freightCompany){

        if(freightCompany && ("Nome" in freightCompany)){
            this.Nome=freightCompany.Nome
        }

    }

    getName(){
        if("Nome" in this){
            return this.Nome
        }
        return ""
    }


}
